import { render, staticRenderFns } from "./Chart3.vue?vue&type=template&id=2935ff74&scoped=true&"
import script from "./Chart3.vue?vue&type=script&lang=js&"
export * from "./Chart3.vue?vue&type=script&lang=js&"
import style0 from "./Chart3.vue?vue&type=style&index=0&id=2935ff74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2935ff74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
